import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTruckOrderNotUsed extends Layout {
    panelBillForTonu: Panel;
    panelPayDriver: Panel;
    sourceTruckOrderNotUsed: DataSource;
    switchBillForTonu: Switch;
    switchPayDriver: Switch;
    textboxBillingComment: Textbox;
    textboxDeductAmount: Textbox;
    textboxDeductCode: Textbox;
    textboxDeductCurrencyType: Textbox;
    textboxDriverId: Textbox;
    textboxOtherChargeAmount: Textbox;
    textboxOtherChargeCode: Textbox;
    textboxOtherChargeCurrencyType: Textbox;
}
